// @ts-strict-ignore
import { TService } from '@/features/product-services/lib/types'

import { TServiceServer } from '@/shared/types/deprecated-types'

export const servicesAdapter = (servicesResponse: TServiceServer): TService[] =>
	Object.values(servicesResponse).map((item, index) => ({
		ID: index.toString(),
		TITLE: item.TYPE,
		SHORT_TITLE: '',
		DESCRIPTION: '',
		VARIANTS: item.ITEMS
			? item.ITEMS.map(ITEM => ({
					ID: ITEM.ID.toString(),
					TITLE: ITEM.NAME,
					DESCRIPTION: ITEM.DESCRIPTION,
					ICON_SRC: ITEM.PIC ? ITEM.PIC : null,
					DETAIL_PICTURE: ITEM.DETAIL_PICTURE
						? ITEM.DETAIL_PICTURE
						: `/iblock/33b/33b9f350919a9108993e6b9c52d675f5/a51c5ed3bb9086b1e058e615b4f84c1a.png`,
					PRICE: ITEM.PRICE,
					KOD: ITEM.KOD,
					SECTION_ID: ITEM.SECTION_ID
			  }))
			: []
	}))
